<strong mat-dialog-title>{{ data.helpTitle }}</strong>
<mat-dialog-content>
  <span>{{ data.helpText }}</span>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>Got It!</button>
</mat-dialog-actions>
